import { GameFeature as GameFeatureEnum } from '@/models/games/enums/GameFeature';
import { getMainPlayerState } from '@/modules/main/selector';
import { isBitActive } from '@/utils/bitwiseUtil';
import { calcLowHigh } from '@/utils/commonFunc';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useGameFeature = () => {
    const [isHedgeBettingEnabled, setIsHedgeBettingEnabled] =
        useState<boolean>();
    const [isAutoConfirmEnabled, setIsAutoConfirmEnabled] = useState<boolean>();
    const [isSideBetEnabled, setIsSideBetEnabled] = useState<boolean>();
    const [isChatRoomOn, setChatRoomOn] = useState<boolean>();
    // const [isGiftOn, setGiftOn] = useState<boolean>();
    const { GameFeature } = useSelector(getMainPlayerState);

    useEffect(() => {
        const curGameFeature = calcLowHigh(GameFeature);

        setIsHedgeBettingEnabled(
            isBitActive(curGameFeature, GameFeatureEnum.HedgeBetting)
        );
        setIsAutoConfirmEnabled(
            isBitActive(curGameFeature, GameFeatureEnum.AutoBetConfirmation)
        );
        setIsSideBetEnabled(
            isBitActive(curGameFeature, GameFeatureEnum.BaccaratSideBet)
        );
        // setGiftOn(true || isBitActive(curGameFeature, GameFeatureEnum.Tips));
        setChatRoomOn(false);
    }, [GameFeature]);

    return {
        isHedgeBettingEnabled,
        isAutoConfirmEnabled,
        isSideBetEnabled,
        isChatRoomOn,
    };
};
